/* Shared site interactions. Booking remains in its own module. */
(() => {
  const carouselCleanups = new WeakMap();
  function initCarousel(carousel) {
    if(carousel.dataset.ready) return;
    const slides=[...carousel.querySelectorAll('[data-ds-slide]')];
    if(slides.length<2) return;
    carousel.dataset.ready='true';
    const dots=[...carousel.querySelectorAll('[data-ds-slide-dot]')];
    const caption=carousel.querySelector('[data-ds-slide-caption]');
    const status=carousel.querySelector('[data-ds-slide-status]');
    const toggle=carousel.querySelector('[data-ds-slide-toggle]');
    const motion=matchMedia('(prefers-reduced-motion: reduce)');
    const controller=new AbortController(),options={signal:controller.signal};
    let current=0,paused=motion.matches,hovering=false,inView=true,timer,toggleWasPaused;
    const clear=()=>{clearTimeout(timer);timer=null;};
    const updateToggle=()=>{
      toggle.setAttribute('aria-label',paused?'Play slideshow':'Pause slideshow');
      toggle.querySelector('span').textContent=paused?'▶':'Ⅱ';
    };
    const schedule=()=>{
      clear();
      if(paused || hovering || !inView || document.hidden || !carousel.isConnected) return;
      timer=setTimeout(()=>{show(current+1);schedule();},6000);
    };
    const pause=()=>{paused=true;updateToggle();clear();};
    const show=(index,manual=false)=>{
      current=(index+slides.length)%slides.length;
      slides.forEach((slide,i)=>{
        slide.classList.toggle('is-active',i===current);
        if(i===current) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden','true');
      });
      dots.forEach((dot,i)=>{if(i===current)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});
      caption.textContent=slides[current].dataset.caption;
      if(manual){pause();status.textContent=`Photo ${current+1} of ${slides.length}. ${slides[current].querySelector('img').alt}`;}
    };
    carousel.querySelectorAll('[data-ds-carousel-controls]').forEach(node=>node.hidden=false);
    carousel.querySelector('[data-ds-slide-previous]').addEventListener('click',()=>show(current-1,true),options);
    carousel.querySelector('[data-ds-slide-next]').addEventListener('click',()=>show(current+1,true),options);
    dots.forEach((dot,i)=>dot.addEventListener('click',()=>show(i,true),options));
    // Preserve the clicked action when pointer focus also pauses rotation.
    toggle.addEventListener('pointerdown',()=>{toggleWasPaused=paused;},options);
    toggle.addEventListener('click',event=>{
      paused=!(event.detail>0 && toggleWasPaused!==undefined?toggleWasPaused:paused);
      toggleWasPaused=undefined;updateToggle();schedule();
    },options);
    carousel.addEventListener('mouseenter',()=>{hovering=true;clear();},options);
    carousel.addEventListener('mouseleave',()=>{hovering=false;schedule();},options);
    carousel.addEventListener('focusin',pause,options);
    carousel.addEventListener('keydown',event=>{
      if(event.key==='ArrowRight'){event.preventDefault();show(current+1,true);}
      if(event.key==='ArrowLeft'){event.preventDefault();show(current-1,true);}
    },options);
    document.addEventListener('visibilitychange',schedule,options);
    motion.addEventListener('change',pause,options);
    const observer=typeof IntersectionObserver==='undefined'?null:new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;schedule();},{threshold:.15});
    if(observer)observer.observe(carousel);
    updateToggle();schedule();
    carouselCleanups.set(carousel,()=>{clear();observer?.disconnect();controller.abort();delete carousel.dataset.ready;carouselCleanups.delete(carousel);});
  }
  function init(root = document) {
    root.querySelectorAll('[data-ds-carousel]').forEach(initCarousel);
    root.querySelectorAll('.ds-mobile-menu').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready='true';
      menu.addEventListener('click', event => {if(event.target.closest('a')) menu.open=false;});
      menu.addEventListener('keydown', event => {if(event.key==='Escape'){menu.open=false;menu.querySelector('summary').focus();}});
    });
    root.querySelectorAll('[data-ds-contact-preview]').forEach(form => {
      if(form.dataset.ready) return;
      form.dataset.ready='true';
      form.addEventListener('submit', event => {
        event.preventDefault();
        const result=form.querySelector('[data-ds-contact-result]');
        result.textContent='Preview only. Your message has not been sent.';
        result.hidden=false;
      });
    });
    const dialog=root.querySelector('[data-ds-gallery-dialog]');
    if(!dialog || dialog.dataset.ready || !dialog.showModal) return;
    dialog.dataset.ready='true';
    const links=[...root.querySelectorAll('[data-ds-lightbox]')];
    if(!links.length) return;
    let current=0;
    const show=index=>{
      current=(index+links.length)%links.length;
      const source=links[current].querySelector('img'),photo=dialog.querySelector('[data-ds-photo]');
      photo.src=links[current].href;photo.alt=source.alt;
      dialog.querySelector('[data-ds-photo-count]').textContent=`${current+1} / ${links.length}`;
    };
    links.forEach((link,index)=>link.addEventListener('click',event=>{event.preventDefault();show(index);dialog.showModal();}));
    dialog.querySelector('[data-ds-photo-close]').addEventListener('click',()=>dialog.close());
    dialog.querySelector('[data-ds-photo-previous]').addEventListener('click',()=>show(current-1));
    dialog.querySelector('[data-ds-photo-next]').addEventListener('click',()=>show(current+1));
    dialog.addEventListener('keydown',event=>{if(event.key==='ArrowRight'){event.preventDefault();show(current+1);}if(event.key==='ArrowLeft'){event.preventDefault();show(current-1);}});
    dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
    dialog.addEventListener('close',()=>links[current].focus({preventScroll:true}));
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-ds-carousel]').forEach(carousel=>carouselCleanups.get(carousel)?.()));
})();
